import { render } from "./TheQuyMoTruongChuan.vue?vue&type=template&id=6b90ecd4"
import script from "./TheQuyMoTruongChuan.vue?vue&type=script&lang=js"
export * from "./TheQuyMoTruongChuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__